<template>
    <RegistrationAndLoginError></RegistrationAndLoginError>
</template>

<script>
    import RegistrationAndLoginError from "../components/RegistrationAndLoginError";

    export default {
        name: "registration-and-login-error",
        components: {
            RegistrationAndLoginError,
        }
    };
</script>